import { render, staticRenderFns } from "./ImPage.vue?vue&type=template&id=778449c1&scoped=true&"
import script from "./ImPage.vue?vue&type=script&lang=js&"
export * from "./ImPage.vue?vue&type=script&lang=js&"
import style0 from "./ImPage.vue?vue&type=style&index=0&id=778449c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778449c1",
  null
  
)

export default component.exports